module.exports = __webpack_public_path__ + "img/red_007.1eeee346.png";